const state = {
	spinWheelData: null,
}

const getters = {
	getSpinwinData: (state) => (id) => {
		return state.spinWheelData?.find((item) => item.id === id) || null;
	}
}

const actions = {
	/*fetchSpinWheelData({ commit }) {
		axios
			.post('/api/spinwin/spin')
			.then(response => {
				const data = response.data;
				commit('setSpinWheelData', data); // Commit the data to mutation
			})
			.catch(error => console.log(error));
	}*/
}

const mutations = {
	setSpinWheelData(state, data) {
		state.spinWheelData = data;
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
